export default "__VITE_ASSET__BdvhVo6X__"